export const KantorkuSwitcherIcon = (props: JSX.IntrinsicElements['svg']) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0.5L2.61672 0.500006V9.48401L0 9.48401V0.5Z" fill="#6913D8" />
      <path
        d="M4.0798 0.982502C3.59545 1.31742 3.35327 1.97182 3.35327 2.94571V4.52553H3.96303C5.19986 4.52553 6.07125 4.314 6.57723 3.89096C7.07455 3.46791 7.32321 2.75842 7.32321 1.7625V0.513184H6.66804C5.40095 0.513184 4.5382 0.669623 4.0798 0.982502Z"
        fill="#FEE156"
      />
      <path
        d="M3.96303 5.21289H3.35327V6.86542C3.35327 7.85694 3.59545 8.54439 4.0798 8.92778C4.56415 9.30676 5.4269 9.49625 6.66804 9.49625H7.32321V8.18745C7.32321 7.16949 7.07455 6.42475 6.57723 5.95322C6.05396 5.45967 5.18256 5.21289 3.96303 5.21289Z"
        fill="#6913D8"
      />
      <circle cx="8.62701" cy="8.76275" r="0.666075" fill="#FEE156" />
    </svg>
  );
};
